import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f73234f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-tag-container" }
const _hoisted_3 = {
  key: 0,
  class: "card-tag"
}
const _hoisted_4 = { class: "card-tag__content" }
const _hoisted_5 = {
  class: "card-tag__right",
  ref: "firstCardRef"
}
const _hoisted_6 = { class: "card-tag" }
const _hoisted_7 = { class: "card-tag__content" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "analysis-badge" }, " Em análise ", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "card-image" }
const _hoisted_12 = { class: "map-container" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "card-content" }
const _hoisted_15 = { class: "card-title-container regular-h5" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "title" }
const _hoisted_18 = {
  key: 1,
  class: "id"
}
const _hoisted_19 = { class: "card-location" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-alt-fill" }, null, -1))
const _hoisted_21 = { class: "card-location location" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-fill" }, null, -1))
const _hoisted_23 = { class: "card-location" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-rulers areaIcon" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_26 = { class: "card-bottom" }
const _hoisted_27 = { class: "card-left" }
const _hoisted_28 = { class: "card-icon" }
const _hoisted_29 = { class: "card-label regular-label" }
const _hoisted_30 = { class: "card-right" }
const _hoisted_31 = { class: "card-icon" }
const _hoisted_32 = { class: "card-label regular-label" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_34 = { class: "card-actions" }
const _hoisted_35 = {
  key: 1,
  class: "study-btn-disabled"
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.tagVgvValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "card-tag__left",
                  style: _normalizeStyle('background:' + _ctx.tagVgvColor + ';')
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.tagVgv), 1)
                ], 4),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.tagVgvValue), 1)
                ], 512)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.tagRoiValue)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "card-tag__left",
                  style: _normalizeStyle([_ctx.cardTagMargin, 'background:' + _ctx.tagVgvColor])
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.tagRoi), 1)
                ], 4))
              : _createCommentVNode("", true),
            (_ctx.tagRoiValue)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "card-tag__right",
                  style: _normalizeStyle(_ctx.cardTagMargin)
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.tagRoiValue), 1)
                ], 4))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_ctx.status === 'analise')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("img", {
            class: "card-image map",
            src: _ctx.imageMapName ? _ctx.imageMapName : _ctx.defaultImageSrc,
            onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args))),
            alt: "Map"
          }, null, 40, _hoisted_13)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (_ctx.iconTitle)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: _normalizeClass(["img-title", { 'demo-title': _ctx.title === 'DEMONSTRAÇÃO' }]),
                src: _ctx.iconTitle,
                alt: "Card Image"
              }, null, 10, _hoisted_16))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.title), 1),
          (_ctx.gidImovel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Ref: " + _toDisplayString(_ctx.gidImovel), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("span", null, _toDisplayString(_ctx.cityAndState ? _ctx.cityAndState : '–'), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("span", null, _toDisplayString(_ctx.location ? _ctx.location : '–'), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("span", null, _toDisplayString(_ctx.formattedAreaLote), 1)
        ]),
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.iconLeft)
              }, null, 2)
            ]),
            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.recommendation), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.iconRight)
              }, null, 2)
            ]),
            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.nearby), 1)
          ])
        ]),
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          (_ctx.biURL && !_ctx.disableStudyView)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "study-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleOpportunityClick()))
              }, "Ver estudo"))
            : _createCommentVNode("", true),
          (!_ctx.biURL || _ctx.disableStudyView)
            ? (_openBlock(), _createElementBlock("button", _hoisted_35, "Ver estudo"))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "whatsapp-btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleWhatsAppClick && _ctx.handleWhatsAppClick(...args)))
          }, "Whatsapp")
        ])
      ])
    ]),
    (_ctx.routeName === 'home')
      ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
          (_ctx.showTooltip)
            ? (_openBlock(), _createBlock(_component_Tooltip, {
                key: 0,
                position: "translate(-319px, -163px)",
                title: _ctx.tooltipTitle,
                title2: _ctx.tooltipInfo,
                tooltipData: _ctx.tooltipData
              }, null, 8, ["title", "title2", "tooltipData"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_37, [
          (_ctx.showTooltip)
            ? (_openBlock(), _createBlock(_component_Tooltip, {
                key: 0,
                position: "translate(-159px, -327px)",
                title: _ctx.tooltipTitle,
                title2: _ctx.tooltipInfo,
                tooltipData: _ctx.tooltipData
              }, null, 8, ["title", "title2", "tooltipData"]))
            : _createCommentVNode("", true)
        ]))
  ]))
}